import { HttpClient } from '../../gateways'
import { UnexpectedError } from '../../models/errors'
import { setupIntranetV2ApiClient } from '../../proxies/apis/intranet-v2'
import { HttpStatusCode } from '../../types/gateways'

type ExportarRelatorioConsumoAlmocoInput = {
  params?: any
}

type ExportarRelatorioConsumoAlmocoOutput = {
  body?: Blob
  headers?: any
}

export const exportarRelatorioConsumoAlmoco = async (
  input?: ExportarRelatorioConsumoAlmocoInput
): Promise<ExportarRelatorioConsumoAlmocoOutput> => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: '/restaurante/relatorio-consumo-almoco/exportar',
    method: 'GET',
    params: input?.params,
    responseType: 'blob'
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return {
        body: response.body,
        headers: response.headers
      }

    default:
      throw new UnexpectedError()
  }
}
